import React from 'react'

import './MillionsShoppersSlide.scss'

export const MillionsShoppersSlide = (): React.ReactElement => {
  return (
    <div className="slide-container">
      <div className="consumerImage-2" />
      <h1 className="header-consumer-2 mt-4 mb-2">{`Millions on shoppers' habits`}</h1>
      <p className="subheader-consumer-2">
        {`Use comprehensive consumer information from the world's largest purchase journey study to understand the full context for buyers' behaviour.`}
      </p>
      <p className="text-sm text-inactive productConsumer">gfknewron Consumer</p>
    </div>
  )
}
